import type {FC} from 'react';

import {CookieDeclaration} from '@/components/content-blocks/cookie-declaration';
import {LinkListSelection} from '@/components/content-blocks/link-list-selection';
import {DocumentListSelectionContainer} from '@/modules/page/sanity/content-blocks/document-list-selection-container';
import {GalleryContainer} from '@/modules/page/sanity/content-blocks/gallery-container';
import {TextContainer} from '@/modules/page/sanity/content-blocks/text-container';
import {TextWithImageSplitContainer} from '@/modules/page/sanity/content-blocks/text-with-image-split-container';
import {PersonListSelectionContainer} from '@/modules/person/sanity/person-list-selection-container';
import {ProductListAllContainer} from '@/modules/product/sanity/product-list-all-container';
import type {SanityArray} from '@/sanity/lib/types';

import type {ContentBlockFragment} from './query';

interface Props {
	content: SanityArray<ContentBlockFragment>;
}

const ContentBlocks: FC<Props> = ({content}) => {
	const sections = content?.map((section) => {
		switch (section._type) {
			case 'textSection':
				return <TextContainer key={section._key} data={section} />;
			case 'textWithImageSplit':
				return <TextWithImageSplitContainer key={section._key} data={section} />;
			case 'gallery':
				return <GalleryContainer key={section._key} data={section} />;
			case 'documentListSelection':
				return <DocumentListSelectionContainer key={section._key} data={section} />;
			case 'productListAll':
				return <ProductListAllContainer key={section._key} data={section} />;
			case 'personListSelection':
				return <PersonListSelectionContainer key={section._key} data={section} />;
			case 'linkListSelection':
				return <LinkListSelection key={section._key} data={section} />;
			case 'cookieDeclaration':
				return <CookieDeclaration key={section._key} data={section} />;
			default:
				return null;
		}
	});

	return <>{sections}</>;
};

export default ContentBlocks;
